import { render, staticRenderFns } from "./PublishDate.vue?vue&type=template&id=f1c11346&scoped=true&"
import script from "./PublishDate.vue?vue&type=script&lang=js&"
export * from "./PublishDate.vue?vue&type=script&lang=js&"
import style0 from "./PublishDate.vue?vue&type=style&index=0&id=f1c11346&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c11346",
  null
  
)

export default component.exports